import { REGISTRATION_NUMBER_CHARACTER_LIMIT } from '@shared/constants';

export const beforeYouStartContent = {
  reportsAccepted: {
    sectionTitle: 'We accept reports about vehicles that:',
    itemList: [
      'have been poorly parked or stationary for a significant period of time',
      'are significantly damaged',
      'are missing both registration plates',
    ],
  },
  needToKnowItems: {
    sectionTitle: 'To help resolve the issue quickly, we need to know:',
    itemList: [`the location`, `the make, model and colour of the vehicle`],
  },
  helpfulToInclude: {
    sectionTitle: `It's helpful to include:`,
    itemList: ['the registration number', 'photos of the issue'],
  },
  linkObjectArrays: [
    {
      level: 1,
      title: 'Home',
      href: 'https://www.westminster.gov.uk/',
    },
    {
      level: 2,
      title: 'Report it',
      href: 'https://www.westminster.gov.uk/report-it',
    },
    {
      level: 3,
      title: `Abandoned vehicle`,
    },
  ],
};

export const dangerousPositionQuestions = [
  {
    title: 'Has the vehicle been left in a dangerous position?',
    key: 'isLeftInDangerousPosition',
  },
  {
    title: 'Have you contacted the police?',
    key: 'hasContactedPolice',
  },
];

export const involvedInAccidentQuestions = [
  {
    title: 'Has the vehicle been involved in an accident?',
    key: 'isInvolvedInAccident',
  },
  {
    title: 'Have you contacted the police?',
    key: 'hasContactedPolice',
  },
];

export const leakingQuestions = [
  {
    title: 'Is fuel or oil leaking from the vehicle?',
    key: 'isLeaking',
  },
];

export const issueTypeInfoBoxData = {
  title: 'This vehicle might not be abandoned',
  infoText: `We can only action on reports where our officers find clear evidence that the vehicle is abandoned. This is usually if it matches one of the issues above.`,
};

export const issueTypeTextAreaData = {
  labelText: 'Please describe the issue',
  description: 'For example, how is the vehicle damaged or badly parked?',
  maxLength: 500,
};

export const issueTypeQuestionData = {
  title: 'What is the issue?',
  description: 'Select the type of issue',
  errorPath: 'issueType',
};

export const howLongQuestionData = {
  title: 'How long has the vehicle been there?',
  errorPath: 'howLong',
};

export const vehicleDetailsQuestionData = {
  title: 'Details of the vehicle',
  textInputList: [
    {
      id: 'registrationNumber',
      labelText: 'Registration number (optional)',
      description:
        'Please provide this if possible, as it will help us check the information with the DVLA.',
      errorPath: 'registrationNumber',
      maxLength: REGISTRATION_NUMBER_CHARACTER_LIMIT,
    },
    {
      id: 'make',
      labelText: 'Make',
      errorPath: 'make',
      maxLength: 100,
    },
    {
      id: 'model',
      labelText: 'Model',
      errorPath: 'model',
      maxLength: 100,
    },
    {
      id: 'colour',
      labelText: 'Colour',
      errorPath: 'colour',
      maxLength: 100,
    },
  ],
};

export const locationQuestionData = {
  id: 'issueLocation',
  errorPath: 'issueLocation',
  locationStored: {
    labelText: 'Check if the location is correct',
    subText: (
      <div className="text-bodyLg my-2 flex flex-col gap-4">
        <p>We used your photo to find where the issue is located.</p>
        <p>You can change where the issue is located using the map.</p>
      </div>
    ),
  },
  locationNotStored: {
    title: 'Location of the issue',
    subText: 'Please select a location on the map',
  },
  additionalLocationDetails: {
    id: 'additionalLocationDetails',
    errorPath: 'additionalLocationDetails',
    labelText:
      'Do you have any more information about the location (optional)?',
    description:
      'For example, is the vehicle close to a shop, a road junction or other landmark?',
    maxLength: 500,
  },
};

export const emailConfirmationQuestionData = {
  title: 'Do you want a confirmation email of your report?',
  key: 'emailConfirmation',
  options: [
    {
      labelText: 'Yes',
    },
    {
      labelText: 'No',
    },
  ],
};
